/* ============================================================
   x-compare — Compare tray + compare page, lookbook pins,
   search sort. Self-contained; does not depend on theme.js
   internals. Vanilla JS, data-attribute patterns.
   ============================================================ */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var KEY = 'lux_compare';
  var MAX = 4;

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function setList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); }
    catch (e) {}
  }
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'Rs ' + parts.join('.');
  }
  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer = null;
  function toast(msg) {
    var t = $('#x-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'x-toast';
      t.className = 'x-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Floating compare tray (injected, no layout edit needed) ---------- */
  function renderTray() {
    var list = getList();
    var tray = $('#x-tray');
    if (!tray) {
      tray = document.createElement('div');
      tray.id = 'x-tray';
      tray.className = 'x-tray';
      tray.setAttribute('role', 'region');
      tray.setAttribute('aria-label', 'Product compare');
      tray.innerHTML =
        '<span class="x-tray__label">Compare <span class="x-tray__count" data-x-tray-count>0</span></span>' +
        '<a class="x-tray__go" href="/pages/compare" data-x-tray-go>Compare now</a>' +
        '<button type="button" class="x-tray__clear" data-x-tray-clear>Clear</button>';
      document.body.appendChild(tray);
      tray.addEventListener('click', function (e) {
        if (e.target.closest('[data-x-tray-clear]')) {
          e.preventDefault();
          setList([]);
          syncCompareButtons();
          renderTray();
          if ($('[data-x-compare-page]')) renderCompareTable();
        }
      });
    }
    var count = $('[data-x-tray-count]', tray);
    if (count) count.textContent = list.length;
    tray.classList.toggle('is-visible', list.length > 0);
  }

  /* ---------- Compare toggles on product cards ---------- */
  function syncCompareButtons() {
    var list = getList();
    $all('[data-compare]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-compare')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-compare]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-compare');
    var list = getList();
    var i = list.indexOf(handle);
    if (i !== -1) {
      list.splice(i, 1);
      toast('Removed from compare');
    } else {
      if (list.length >= MAX) {
        toast('You can compare up to ' + MAX + ' products');
        return;
      }
      list.push(handle);
      toast('Added to compare');
    }
    setList(list);
    syncCompareButtons();
    renderTray();
  });

  /* ---------- Compare page table ---------- */
  function productImage(p) {
    if (p.featured_image) return p.featured_image;
    if (p.images && p.images.length) return p.images[0];
    return '';
  }
  function starsRow() {
    return '<span class="compare-table__stars" aria-label="No reviews yet">★★★★★<small>No reviews yet</small></span>';
  }

  function renderCompareTable() {
    var mount = $('[data-x-compare-mount]');
    if (!mount) return;
    var list = getList();
    var emptyTpl = $('#x-compare-empty');
    var loadingTpl = $('#x-compare-loading');

    if (!list.length) {
      mount.innerHTML = emptyTpl ? emptyTpl.innerHTML : '<p>Your compare list is empty.</p>';
      return;
    }
    mount.innerHTML = loadingTpl ? loadingTpl.innerHTML : '<p class="compare-loading">Loading…</p>';

    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) {
        mount.innerHTML = emptyTpl ? emptyTpl.innerHTML : '<p>Your compare list is empty.</p>';
        return;
      }
      var showVendor = mount.getAttribute('data-show-vendor') === 'true';
      var showRating = mount.getAttribute('data-show-rating') === 'true';

      var html = '<div class="compare-page__table-wrap"><table class="compare-table"><thead><tr><th class="compare-table__label"></th>';
      products.forEach(function (p) {
        html += '<th><button type="button" class="compare-table__remove" data-x-remove="' + escapeHTML(p.handle) + '" aria-label="Remove ' + escapeHTML(p.title) + ' from compare">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>Remove</button></th>';
      });
      html += '</tr></thead><tbody>';

      html += '<tr><td class="compare-table__label">Product</td>';
      products.forEach(function (p) {
        var img = productImage(p);
        html += '<td>' +
          (img ? '<img class="compare-table__img" src="' + escapeHTML(img) + '" alt="' + escapeHTML(p.title) + '" loading="lazy">' : '') +
          '<p class="compare-table__title"><a href="' + escapeHTML(p.url) + '">' + escapeHTML(p.title) + '</a></p>' +
          (showVendor && p.vendor ? '<p class="compare-table__vendor">' + escapeHTML(p.vendor) + '</p>' : '') +
          '</td>';
      });
      html += '</tr>';

      html += '<tr><td class="compare-table__label">Price</td>';
      products.forEach(function (p) {
        var sale = p.compare_at_price && p.compare_at_price > p.price;
        html += '<td><span class="price-wrap">' +
          (sale ? '<s class="price-compare">' + formatMoney(p.compare_at_price) + '</s>' : '') +
          '<span class="price' + (sale ? ' price--sale' : '') + '">' + formatMoney(p.price) + '</span></span></td>';
      });
      html += '</tr>';

      if (showRating) {
        html += '<tr><td class="compare-table__label">Rating</td>';
        products.forEach(function () { html += '<td>' + starsRow() + '</td>'; });
        html += '</tr>';
      }

      html += '<tr><td class="compare-table__label">Availability</td>';
      products.forEach(function (p) {
        html += '<td>' + (p.available
          ? '<span class="compare-table__stock--in">In stock</span>'
          : '<span class="compare-table__stock--out">Sold out</span>') + '</td>';
      });
      html += '</tr>';

      html += '<tr><td class="compare-table__label">Options</td>';
      products.forEach(function (p) {
        var n = (p.variants && p.variants.length) || 1;
        html += '<td>' + n + (n === 1 ? ' option' : ' options') + '</td>';
      });
      html += '</tr>';

      html += '<tr><td class="compare-table__label"></td>';
      products.forEach(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        html += '<td>' + (v
          ? '<button type="button" class="btn btn--primary" data-x-add="' + v.id + '">Add to bag</button>'
          : '<button type="button" class="btn btn--secondary" disabled>Sold out</button>') + '</td>';
      });
      html += '</tr>';

      html += '</tbody></table></div>';
      mount.innerHTML = html;
    });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-x-remove]');
    if (rm) {
      var list = getList().filter(function (h) { return h !== rm.getAttribute('data-x-remove'); });
      setList(list);
      syncCompareButtons();
      renderTray();
      renderCompareTable();
      return;
    }
    var clearAll = e.target.closest('[data-x-clear-all]');
    if (clearAll) {
      setList([]);
      syncCompareButtons();
      renderTray();
      renderCompareTable();
      return;
    }
    var add = e.target.closest('[data-x-add]');
    if (add) {
      var btn = add;
      var fd = new FormData();
      fd.append('id', btn.getAttribute('data-x-add'));
      fd.append('quantity', '1');
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          $all('[data-cart-count-bubble]').forEach(function (b) {
            b.textContent = cart.item_count;
            b.hidden = cart.item_count === 0;
          });
          setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          toast('Could not add to bag');
        });
    }
  });

  /* ---------- Lookbook pins ---------- */
  $all('[data-lookbook]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var pin = e.target.closest('[data-lookbook-pin]');
      var close = e.target.closest('[data-lookbook-close]');
      var cards = $all('[data-lookbook-card]', root);
      if (close) {
        close.closest('[data-lookbook-card]').hidden = true;
        var p = close.closest('[data-lookbook-spot]').querySelector('[data-lookbook-pin]');
        if (p) p.setAttribute('aria-expanded', 'false');
        return;
      }
      if (pin) {
        var spot = pin.closest('[data-lookbook-spot]');
        var card = spot ? spot.querySelector('[data-lookbook-card]') : null;
        var wasHidden = card && card.hidden;
        cards.forEach(function (c) { c.hidden = true; });
        $all('[data-lookbook-pin]', root).forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
        if (card && wasHidden) {
          card.hidden = false;
          pin.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (!e.target.closest('[data-lookbook-card]')) {
        cards.forEach(function (c) { c.hidden = true; });
        $all('[data-lookbook-pin]', root).forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        $all('[data-lookbook-card]', root).forEach(function (c) { c.hidden = true; });
        $all('[data-lookbook-pin]', root).forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      }
    });
  });

  /* ---------- Search sort dropdown ---------- */
  $all('[data-x-search-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (sel.value) { url.searchParams.set('sort_by', sel.value); }
      else { url.searchParams.delete('sort_by'); }
      window.location.href = url.toString();
    });
  });

  /* ---------- Init ---------- */
  syncCompareButtons();
  renderTray();
  if ($('[data-x-compare-page]')) renderCompareTable();
})();
